import { MarkedByEnum, QuestionTypeEnum } from '@doltech/utils/lib/constants';
import { numberToABC, numberToRoman } from '@doltech/utils/lib/text';

function MatchingQuestionMappingHelper(type, data, markedBy = null) {
  const matchingHeadingTitlePrefix = 'Paragraph';
  const matchingParagraphTitlePrefix = 'Paragraph';

  const numberToString =
    markedBy === MarkedByEnum.ABECEDARIUM_LATINUM ? numberToRoman : numberToABC;
  switch (type) {
    case QuestionTypeEnum.MATCHING_HEADING: {
      const { index, paragraphKeys, options, correction, userAnswer } = data;
      const sortedParagraphKeys = [...paragraphKeys].sort();
      const correct = options[correction.key];
      const wrong = options[userAnswer];
      return {
        ...data,
        headerTitle: `${matchingHeadingTitlePrefix} ${numberToABC(sortedParagraphKeys[index] + 1)}`,
        correct: {
          text: `${correct.value}`,
          circleText: numberToRoman(correct.key + 1),
        },
        wrong: {
          text: `${wrong?.value}`,
          circleText: numberToRoman(wrong?.key + 1),
        },
      };
    }
    case QuestionTypeEnum.MATCHING_FEATURE_NAME: {
      const { featureNames, index, options, correction, userAnswer } = data;
      const correct = options[correction.key];
      const wrong = options[userAnswer];
      return {
        ...data,
        headerTitle: featureNames[index].value,
        correct: {
          text: `${correct.value}`,
          circleText: numberToABC(correct.key + 1),
        },
        wrong: {
          text: `${wrong?.value}`,
          circleText: numberToABC(wrong?.key + 1),
        },
      };
    }
    case QuestionTypeEnum.MATCHING_PARAGRAPH: {
      const { option, correction, userAnswer } = data;
      const correct = numberToString(correction.key + 1);
      const wrong = numberToString(userAnswer + 1);
      return {
        ...data,
        headerTitle: option.value,
        correct: {
          text: `${matchingParagraphTitlePrefix} ${correct}`,
          circleText: correct,
        },
        wrong: {
          text: `${matchingParagraphTitlePrefix} ${wrong}`,
          circleText: wrong,
        },
      };
    }
    case QuestionTypeEnum.MATCHING_ENDING: {
      const { option, options, correction, userAnswer } = data;
      const correct = options[correction.key];
      const wrong = options[userAnswer];
      return {
        ...data,
        headerTitle: option.value,
        correct: {
          text: `${correct.value}`,
          circleText: numberToABC(correct.key + 1),
        },
        wrong: {
          text: `${wrong?.value}`,
          circleText: numberToABC(wrong?.key + 1),
        },
      };
    }
  }
}

export default MatchingQuestionMappingHelper;
